import React from 'react';
import * as Icon from 'react-feather';

import PermissionCode from '@modules/roles/contantsPermissions';
import { IRouter } from '@routers/interface';

export const routerCost: IRouter = {
  path: '/cost',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'cost.sidename', //translate here for breadcrumb and sidebar
  menu: {
    icon: <Icon.DollarSign />,
  },
  permissionCode: PermissionCode.FEES_SEARCH,
};
